export default __webpack_public_path__ + "static/media/fast.4e628e3c.png";